import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import { Observable, catchError, map, of } from 'rxjs';
import { AuthService } from '../shared/services/auth.service';
import { DistributionService } from '../modules/services/distribution.service';
import { ApiResponse } from '../shared/services/types/api-schema.types';



@Injectable({
    providedIn: 'root',
  })
  export class AuthGuard implements CanActivate {
    constructor(private router:Router, private authService: AuthService){}
    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot):
      | Observable<boolean | UrlTree>
      | Promise<boolean | UrlTree>
      | boolean
      | UrlTree {
      const token = this.authService.getToken();      
      if (token) {
        return true;
      } else {
       this.router.navigate(['/']);
        return false;
      }
    }
  }



@Injectable({
  providedIn: 'root',
})
export class allowedCreateAnnouncementGuard implements CanActivate {
  constructor(private router:Router, private distributionService: DistributionService){}
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> {
    return this.distributionService.getAllAnnouncement().pipe(
      map((res: ApiResponse<any>) => {
        const announcementList = res.data.docs;

        if (announcementList.length < 1) {
          // Allow navigation if no announcements exist
          return true;
        } else {
          // Redirect to home page if announcements already exist
          return this.router.createUrlTree(['announcement']);
        }
      }),
      catchError((err) => {
        // Handle error (e.g., API failure) and optionally block navigation
        console.error('Error fetching announcements:', err);
        return of(this.router.createUrlTree(['/'])); // Redirect to home on error
      })
    );
  }
  }